import { t } from 'es6/services/localization';

/**
 * @param {String} langCode    short hand language code
 */
export function language(langCode) {
  switch (langCode.toLowerCase()) {
    case 'aa':
      return t('language-display-aa');
    case 'ab':
      return t('language-display-ab');
    case 'af':
      return t('language-display-af');
    case 'ak':
      return t('language-display-ak');
    case 'am':
      return t('language-display-am');
    case 'ar':
      return t('language-display-ar');
    case 'an':
      return t('language-display-an');
    case 'as':
      return t('language-display-as');
    case 'av':
      return t('language-display-av');
    case 'ae':
      return t('language-display-ae');
    case 'ay':
      return t('language-display-ay');
    case 'az':
      return t('language-display-az');
    case 'ba':
      return t('language-display-ba');
    case 'bm':
      return t('language-display-bm');
    case 'be':
      return t('language-display-be');
    case 'bn':
      return t('language-display-bn');
    case 'bi':
      return t('language-display-bi');
    case 'bo':
      return t('language-display-bo');
    case 'bs':
      return t('language-display-bs');
    case 'br':
      return t('language-display-br');
    case 'bg':
      return t('language-display-bg');
    case 'ca':
      return t('language-display-ca');
    case 'cs':
      return t('language-display-cs');
    case 'ch':
      return t('language-display-ch');
    case 'ce':
      return t('language-display-ce');
    case 'cu':
      return t('language-display-cu');
    case 'cv':
      return t('language-display-cv');
    case 'kw':
      return t('language-display-kw');
    case 'co':
      return t('language-display-co');
    case 'cr':
      return t('language-display-cr');
    case 'cy':
      return t('language-display-cy');
    case 'da':
      return t('language-display-da');
    case 'de':
      return t('language-display-de');
    case 'dv':
      return t('language-display-dv');
    case 'dz':
      return t('language-display-dz');
    case 'el':
      return t('language-display-el');
    case 'en':
      return t('language-display-en');
    case 'eo':
      return t('language-display-eo');
    case 'et':
      return t('language-display-et');
    case 'eu':
      return t('language-display-eu');
    case 'ee':
      return t('language-display-ee');
    case 'fo':
      return t('language-display-fo');
    case 'fa':
      return t('language-display-fa');
    case 'fj':
      return t('language-display-fj');
    case 'fi':
      return t('language-display-fi');
    case 'fr':
      return t('language-display-fr');
    case 'fy':
      return t('language-display-fy');
    case 'ff':
      return t('language-display-ff');
    case 'gd':
      return t('language-display-gd');
    case 'ga':
      return t('language-display-ga');
    case 'gl':
      return t('language-display-gl');
    case 'gv':
      return t('language-display-gv');
    case 'gn':
      return t('language-display-gn');
    case 'gu':
      return t('language-display-gu');
    case 'ht':
      return t('language-display-ht');
    case 'ha':
      return t('language-display-ha');
    case 'he':
      return t('language-display-he');
    case 'hz':
      return t('language-display-hz');
    case 'hi':
      return t('language-display-hi');
    case 'ho':
      return t('language-display-ho');
    case 'hr':
      return t('language-display-hr');
    case 'hu':
      return t('language-display-hu');
    case 'hy':
      return t('language-display-hy');
    case 'ig':
      return t('language-display-ig');
    case 'io':
      return t('language-display-io');
    case 'ii':
      return t('language-display-ii');
    case 'iu':
      return t('language-display-iu');
    case 'ia':
      return t('language-display-ia');
    case 'id':
      return t('language-display-id');
    case 'ik':
      return t('language-display-ik');
    case 'is':
      return t('language-display-is');
    case 'it':
      return t('language-display-it');
    case 'jv':
      return t('language-display-jv');
    case 'ja':
      return t('language-display-ja');
    case 'kl':
      return t('language-display-kl');
    case 'kn':
      return t('language-display-kn');
    case 'ks':
      return t('language-display-ks');
    case 'ka':
      return t('language-display-ka');
    case 'kr':
      return t('language-display-kr');
    case 'kk':
      return t('language-display-kk');
    case 'km':
      return t('language-display-km');
    case 'ki':
      return t('language-display-ki');
    case 'rw':
      return t('language-display-rw');
    case 'ky':
      return t('language-display-ky');
    case 'kv':
      return t('language-display-kv');
    case 'kg':
      return t('language-display-kg');
    case 'ko':
      return t('language-display-ko');
    case 'kj':
      return t('language-display-kj');
    case 'ku':
      return t('language-display-ku');
    case 'lo':
      return t('language-display-lo');
    case 'la':
      return t('language-display-la');
    case 'lv':
      return t('language-display-lv');
    case 'li':
      return t('language-display-li');
    case 'ln':
      return t('language-display-ln');
    case 'lt':
      return t('language-display-lt');
    case 'lb':
      return t('language-display-lb');
    case 'lu':
      return t('language-display-lu');
    case 'lg':
      return t('language-display-lg');
    case 'mh':
      return t('language-display-mh');
    case 'ml':
      return t('language-display-ml');
    case 'mr':
      return t('language-display-mr');
    case 'mk':
      return t('language-display-mk');
    case 'mg':
      return t('language-display-mg');
    case 'mt':
      return t('language-display-mt');
    case 'mo':
      return t('language-display-mo');
    case 'mn':
      return t('language-display-mn');
    case 'mi':
      return t('language-display-mi');
    case 'ms':
      return t('language-display-ms');
    case 'my':
      return t('language-display-my');
    case 'na':
      return t('language-display-na');
    case 'nv':
      return t('language-display-nv');
    case 'nr':
      return t('language-display-nr');
    case 'nd':
      return t('language-display-nd');
    case 'ng':
      return t('language-display-ng');
    case 'ne':
      return t('language-display-ne');
    case 'nl':
      return t('language-display-nl');
    case 'no':
      return t('language-display-no');
    case 'ny':
      return t('language-display-ny');
    case 'oc':
      return t('language-display-oc');
    case 'oj':
      return t('language-display-oj');
    case 'or':
      return t('language-display-or');
    case 'om':
      return t('language-display-om');
    case 'os':
      return t('language-display-os');
    case 'pa':
      return t('language-display-pa');
    case 'pl':
      return t('language-display-pl');
    case 'pt':
      return t('language-display-pt');
    case 'ps':
      return t('language-display-ps');
    case 'qu':
      return t('language-display-qu');
    case 'rm':
      return t('language-display-rm');
    case 'ro':
      return t('language-display-ro');
    case 'rn':
      return t('language-display-rn');
    case 'ru':
      return t('language-display-ru');
    case 'sg':
      return t('language-display-sg');
    case 'sa':
      return t('language-display-sa');
    case 'si':
      return t('language-display-si');
    case 'sk':
      return t('language-display-sk');
    case 'sl':
      return t('language-display-sl');
    case 'se':
      return t('language-display-se');
    case 'sm':
      return t('language-display-sm');
    case 'sn':
      return t('language-display-sn');
    case 'sd':
      return t('language-display-sd');
    case 'so':
      return t('language-display-so');
    case 'st':
      return t('language-display-st');
    case 'es':
      return t('language-display-es');
    case 'sq':
      return t('language-display-sq');
    case 'sc':
      return t('language-display-sc');
    case 'sr':
      return t('language-display-sr');
    case 'ss':
      return t('language-display-ss');
    case 'su':
      return t('language-display-su');
    case 'sw':
      return t('language-display-sw');
    case 'sv':
      return t('language-display-sv');
    case 'ty':
      return t('language-display-ty');
    case 'ta':
      return t('language-display-ta');
    case 'tt':
      return t('language-display-tt');
    case 'te':
      return t('language-display-te');
    case 'tg':
      return t('language-display-tg');
    case 'tl':
      return t('language-display-tl');
    case 'th':
      return t('language-display-th');
    case 'ti':
      return t('language-display-ti');
    case 'to':
      return t('language-display-to');
    case 'tn':
      return t('language-display-tn');
    case 'ts':
      return t('language-display-ts');
    case 'tk':
      return t('language-display-tk');
    case 'tr':
      return t('language-display-tr');
    case 'tw':
      return t('language-display-tw');
    case 'ug':
      return t('language-display-ug');
    case 'uk':
      return t('language-display-uk');
    case 'ur':
      return t('language-display-ur');
    case 'uz':
      return t('language-display-uz');
    case 've':
      return t('language-display-ve');
    case 'vi':
      return t('language-display-vi');
    case 'vo':
      return t('language-display-vo');
    case 'wa':
      return t('language-display-wa');
    case 'wo':
      return t('language-display-wo');
    case 'xh':
      return t('language-display-xh');
    case 'yi':
      return t('language-display-yi');
    case 'za':
      return t('language-display-za');
    case 'zu':
      return t('language-display-zu');
    case 'zh-hans':
      return t('language-display-zh-hans');
    case 'zh-hant':
      return t('language-display-zh-hant');
    case 'zh-hk':
      return t('language-display-zh-hk');
    case 'zh-tw':
      return t('language-display-zh-tw');
    case 'tlh':
      return t('language-display-tlh');
    case 'qya':
      return t('language-display-qya');
    case 'sjn':
      return t('language-display-sjn');
    case 'ang':
      return t('language-display-ang');
    case 'och':
      return t('language-display-och');
    case 'ojp':
      return t('language-display-ojp');
    case 'grc':
      return t('language-display-grc');
    case 'arc':
      return t('language-display-arc');
    case 'ain':
      return t('language-display-ain');
    case 'haw':
      return t('language-display-haw');
    case 'jbo':
      return t('language-display-jbo');
    case 'xto':
      return t('language-display-xto');
    case 'txb':
      return t('language-display-txb');
    case 'vec':
      return t('language-display-vec');
    case 'hit':
      return t('language-display-hit');
    case 'enm':
      return t('language-display-enm');
    case 'egy':
      return t('language-display-egy');
    case 'ast':
      return t('language-display-ast');
    default:
      return '';
  }
}

/**
 * @param {String} pos                the part of speech (presumably from the server)
 * @param {Boolean} emptyOnNone       returns empty string on none
 * @returns {String}
 */
export function partOfSpeech(pos, emptyOnNone = true) {
  if (emptyOnNone && !pos || pos === 'None') {
    return '';
  } else {
    switch (pos.toLowerCase()) {
      case 'none':
        return t('pos.none');
      case 'proper noun':
        return t('pos.proper noun');
      case 'noun':
        return t('pos.noun');
      case 'phrase':
        return t('pos.phrase');
      case 'verb':
        return t('pos.verb');
      case 'noun abbreviation':
        return t('pos.noun abbreviation');
      case 'adjective':
        return t('pos.adjective');
      case 'conjunction':
        return t('pos.conjunction');
      case 'adverb':
        return t('pos.adverb');
      case 'interrogative':
        return t('pos.interrogative');
      case 'preposition':
        return t('pos.preposition');
      case 'auxiliary verb':
        return t('pos.auxiliary verb');
      case 'pronoun':
        return t('pos.pronoun');
      case 'phrasal verb':
        return t('pos.phrasal verb');
      case 'interjection':
        return t('pos.interjection');
      case 'particle':
        return t('pos.particle');
      case 'verbal noun':
        return t('pos.verbal noun');
      case 'adjectival noun':
        return t('pos.adjectival noun');
      case 'kana':
        return t('pos.kana');
      case 'prefix':
        return t('pos.prefix');
      case 'suffix':
        return t('pos.suffix');
      case 'determiner':
        return t('pos.determiner');
      default:
        return '';
    }
  }
}
